import React, { useState } from "react";


import "./index.scss";
import DupontDialog from "../DupontDialog"

export default function CriticalDeleteDialog(props) {
  const { title, description, onDialogClose, isOverlayLoader, hideReason, type } = props;
  const [deleteReason, setDeleteReason] = useState("");
  const reasonChangeHandler = reason => setDeleteReason(reason);

  const closeHandler = async action => {
    const data = { action };
    if (action === "CONFIRM") {
      data.deleteReason = deleteReason;
    }
    onDialogClose(data);
  };

  return (
    <DupontDialog
      open={true}
      type={type}
      title={title}
      onClose={closeHandler}
      customClass="critical-dialog--width"
      isOverlayLoader={isOverlayLoader}
      cancelBtnText={props.cancelBtnText}
      confirmBtnText={props.confirmBtnText}
    >
      <div className="critical-delete-dailog-main">
        {description}
      </div>
    </DupontDialog>
  );
}
